import { render, staticRenderFns } from "./ExpenseCarouselViewModal.vue?vue&type=template&id=8b9f8f5e&scoped=true&"
import script from "./ExpenseCarouselViewModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseCarouselViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9f8f5e",
  null
  
)

export default component.exports